import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

import { OcpiLocation } from './model';

const client = createClient('/rest/locations');

export const ocpiLocationPermissions = {
  SEARCH: 'cpms.search-locations',
  GET: 'cpms.get-location',
  CREATE: 'cpms.create-location',
  UPDATE: 'cpms.update-location',
  DELETE: 'cpms.delete-location'
};

export const searchOcpiLocations: SearchOperation<OcpiLocation> = (options, customParams, pathVars) => {
  const modifiedParams = customParams ?? new URLSearchParams();
  modifiedParams.append('includeChargingStationCount', '1');
  return searchRequestFactory<OcpiLocation>(client, { pattern: '', permissionId: ocpiLocationPermissions.SEARCH })(
    options,
    modifiedParams,
    pathVars
  );
};

export const getOcpiLocation: FindOperation<OcpiLocation, string> = getRequestFactory<OcpiLocation, string>(client, {
  permissionId: ocpiLocationPermissions.GET
});

export const createOcpiLocation: SaveOperation<OcpiLocation> = postRequestFactory<OcpiLocation>(client, {
  pattern: '',
  permissionId: ocpiLocationPermissions.CREATE
});

export const updateOcpiLocation: SaveOperation<OcpiLocation> = putRequestFactory<OcpiLocation>(client, {
  pattern: '',
  permissionId: ocpiLocationPermissions.UPDATE
});

export const deleteOcpiLocation: DeleteOperation<void> = deleteRequestFactory<void, string>(client, {
  permissionId: ocpiLocationPermissions.DELETE
});
